import { IssueCreditPanel } from "@/components/command-bar/panels";
import type { Command } from "@/lib/commands/types";

// Billing commands are gated by feature_customer_billing. The
// previous "Refund a charge on this load" entry pointed at a
// non-existent backend route (POST /billing/orders/:id/refund) and
// had no chargeId to satisfy the real /billing/charges/:id/refund
// endpoint, so it was removed. Per-charge refunds now live on the
// customer billing page (Charges tab), where each row launches a
// properly-scoped RefundDialog. See launch-plan.md § 19.
export const commandsBilling: Command[] = [
  {
    id: "billing.issue_credit",
    label: "Issue credit to this customer",
    group: "billing",
    scope: "customer_detail",
    permission: "org:billing:write",
    featureFlag: "feature_customer_billing",
    handler: { kind: "panel", open: IssueCreditPanel },
  },
];
